// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero-module--wrapper--17gFZ","heading":"Hero-module--heading--3kqSK","content":"Hero-module--content--3e-0H"};